import { render, staticRenderFns } from "./LabelDetail.vue?vue&type=template&id=15a78a3f&scoped=true&"
import script from "./LabelDetail.vue?vue&type=script&lang=js&"
export * from "./LabelDetail.vue?vue&type=script&lang=js&"
import style0 from "./LabelDetail.vue?vue&type=style&index=0&id=15a78a3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a78a3f",
  null
  
)

export default component.exports